import { render } from "./PbsGroupPage.vue?vue&type=template&id=01189cf6&ts=true"
import script from "./PbsGroupPage.vue?vue&type=script&lang=ts"
export * from "./PbsGroupPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__